export enum ParameterEnum {
  Region = "region",
  Proveniencia = "proveniencia",
  CostSubType = "cost_sub_type",
  Office = "offices"
}
